import React from 'react';
import { Box, Typography } from '@mui/material';
import ideabaaz from '../../../../Assets/images/ideaBaazLogo.svg';
import LinkLogo from '../../../../Assets/Icons/linkLogo.svg';
import instaLogo from '../../../../Assets/Icons/instaLogo.svg';
import zeeLogo from '../../../../Assets/images/zeelogoDark.svg';
import tsLogo from '../../../../Assets/images/tsLogo.svg';
import iitm from '../../../../Assets/images/iitmred.svg';
import { useStyles } from './styles';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Box className={classes.footer}>
      <Box className={classes.content}>
        <Box className={classes.leftSec}>
          <img src={ideabaaz} alt="" className={classes.logo} />
          <Box className={classes.links}>
            {/* <Typography className={classes.textContent} onClick={() => window.open('https://p47reactprodlatest.azureedge.net/')}>
              Visit Project 47
            </Typography> */}
            <Typography className={classes.textContent} onClick={() => navigate(routes.termsAndConditions)}>
              Terms & Conditions
            </Typography>
            <Typography className={classes.textContent} onClick={() => navigate(routes.privacyPolicy)}>
              Privacy Policy
            </Typography>
          </Box>
        </Box>
        <Box className={classes.rightSec}>
          <Box className={classes.rigthLogoContainer}>
            <Box className={classes.logoContainer}>
              <Typography className={classes.textContent2}> Presented by</Typography>
              <img src={zeeLogo} alt="" className={classes.logo1} />
            </Box>
            <Box className={classes.line} />
            <Box className={classes.logoContainer}>
              <Typography className={classes.textContent2}> Official Curation Partner</Typography>
              <img src={tsLogo} alt="" className={classes.logo2} />
            </Box>
            <Box className={classes.line} />

            <Box className={classes.logoContainer}>
              <Typography className={classes.textContent2}> Knowledge Partner</Typography>
              <img src={iitm} alt="" className={classes.logo3} />
            </Box>
          </Box>
          <Box className={classes.rightTextContainer}>
            <Typography className={classes.textContent}>Contact us: support@ideabaaz.co.in</Typography>
            <Box className={classes.rightBottomLogo}>
              <img src={instaLogo} alt="" style={{ width: '20px', cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/ideabaazofficial/')} />
              <img src={LinkLogo} alt="" style={{ width: '18px', cursor: 'pointer' }} onClick={() => window.open('https://www.linkedin.com/company/ideabaazofficial/')} />
              <XIcon sx={{ width: '20px', cursor: 'pointer' }} onClick={() => window.open('https://x.com/_Ideabaaz_')} />
              <FacebookIcon sx={{ width: '25px', cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/ideabaazofficial/')} />
              <YouTubeIcon sx={{ fontSize: '30px', cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/ideabaazofficial/')} />
            </Box>
          </Box>
        </Box>
      </Box>
      <Typography className={classes.copyRights}>© Ideabaaz 2025 | Presented by Zee | Curated by Turbostart</Typography>
    </Box>
  );
};

export default Footer;
